// Pure decision logic for removing a ROM from "My ROMs" (index-screen.js
// removeUserRom). Split out so the destructive path's decisions — confirm
// copy, the DELETE-target system, and the announce strings — get direct
// test coverage without driving window.confirm()/fetch/DOM.
//
// ownership_system targets the actual user_roms row (a gbc-filed claim
// can surface under the gb chip). Deletion copy only when a stored blob
// actually exists: claims (base tiles and claim synthetics, stale or
// not) store no uploaded copy.
export function planRomRemoval(rom) {
  const label = rom.displayName || rom.name;
  const deletesBlob = rom.user_rom === true && rom.claimed !== true;
  const detail = deletesBlob ? ' Its uploaded copy will be deleted.' : '';
  return {
    confirmMessage: `Remove "${label}" from your ROMs?${detail}`,
    system: rom.user_rom ? rom.system : (rom.ownership_system || rom.system),
    successMessage: `Removed from your ROMs: ${label}`,
    failureMessage: `Couldn't remove ${label}. Try again.`,
  };
}
